import { render, staticRenderFns } from "./CAxASCxSocialPt2Page.vue?vue&type=template&id=8889428a"
import script from "./CAxASCxSocialPt2Page.vue?vue&type=script&lang=js"
export * from "./CAxASCxSocialPt2Page.vue?vue&type=script&lang=js"
import style0 from "./CAxASCxSocialPt2Page.vue?vue&type=style&index=0&id=8889428a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports